// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1cRUT","col":"styles_col__1H7Ny"};